import store from '../store'

export const session = async () => {
  const ses = store.getters.calc.calcSession;
  return ses ? ses : await genSession();
};
export const genSession = async () => {
  const uid =
    "id" +
    Math.random()
      .toString(16)
      .slice(2);

  // localStorage.setItem(uid, JSON.stringify(store.getters.calc));
  await store.dispatch("SET_CALC_PARAM", { param: "calcSession", value: uid });
  return uid;
};
